import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import HTMLReactParser from "html-react-parser";
import { convertBrToP , extractFAQFromHTML } from '../common/htmlUtils';
import { Helmet } from "react-helmet";
import classNames from 'classnames';

const Faq = (props) => {
    let titleText = "";
    if(props?.data?.Title) {
        titleText = props?.data?.Title
    }
    if(props?.data?.Heading){
        titleText = props?.data?.Heading
    }

   var faqItems = props?.data?.Accordian_List || props?.data?.Faq_List || [];
    //console.log("faqItems:", faqItems);
    var faqschemaList = [];
        
        faqItems?.map((faqitem,i) =>{
            faqschemaList.push({
                "@type": "Question",
                "name": `${faqitem?.Title}`,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": `${faqitem?.Content}`
                }
            })
        })    
    
    return( 
     <section className='sell-with-us' id={props?.data?.Anchor_Id}>
        {faqItems?.length > 0 && (
                <Helmet>
                   <script type="application/ld+json">{`{
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": ${JSON.stringify(faqschemaList, null, 2)}
                        }`}
                  </script> 
               </Helmet>
            )}
        <Container className='position-relative'>
            <Row className={classNames("justify-content-between", 
                // {"align-items-center": props?.data?.Accordian_List?.length == 0 }
            )}>
                
                <Col lg={12} md={12}>
                    {props?.data?.Sm_Title && <div className="heading pt-2">{props?.data?.Sm_Title}</div>}
                    {titleText && titleText.trim() && <h2>{HTMLReactParser(titleText)}</h2>}
                    {props?.data?.Content && <div class="content">{HTMLReactParser(convertBrToP(props?.data?.Content))}</div>}
                    <Accordion defaultActiveKey={0}>
                        {faqItems && faqItems.map((each, i) => 
                            <Accordion.Item eventKey={i} key={each._id}>
                                <Accordion.Header>{each.Title}</Accordion.Header>
                                <Accordion.Body>
                                    {each.Content && <p>
                                        {HTMLReactParser(each.Content)}
                                    </p>}
                                </Accordion.Body>
                            </Accordion.Item>
                        )}
                    </Accordion>        
                </Col>
            </Row>
        </Container>
    </section>
    )
};

export default Faq;
